export const BULK_SELECTABLE_STATUSES = ["READY", "APPROVED"];

const INDETERMINATE_STATUSES = [
  "DENIED",
  "INCOMPLETE",
  "PENDING",
  "ECHECKPENDING",
  "CASHPENDING",
];

export const normalizeStatus = (confirmationStatus) => {
  if (confirmationStatus == null || confirmationStatus === "") {
    return "";
  }
  if (typeof confirmationStatus === "string") {
    return confirmationStatus.toUpperCase();
  }
  if (typeof confirmationStatus === "object") {
    const raw =
      confirmationStatus.value ??
      confirmationStatus.name ??
      confirmationStatus.label ??
      "";
    return String(raw).toUpperCase();
  }
  return String(confirmationStatus).toUpperCase();
};

export const isEscheatedTransaction = (transaction) => {
  const escheated = transaction?.escheated;
  return escheated === true || escheated === 1;
};

export const isBulkSelectable = (
  confirmationStatus,
  approvedSelectable = true
) => {
  const status = normalizeStatus(confirmationStatus);
  if (!BULK_SELECTABLE_STATUSES.includes(status)) {
    return false;
  }
  if (status === "APPROVED") {
    return approvedSelectable === true;
  }
  return true;
};

export const isBulkSelectableTransaction = (
  transaction,
  approvedSelectable = true
) =>
  !isEscheatedTransaction(transaction) &&
  isBulkSelectable(transaction?.confirmationStatus, approvedSelectable);

export const getApprovedTransactionIds = (transactionList) =>
  (transactionList || [])
    .filter(
      (transaction) =>
        normalizeStatus(transaction.confirmationStatus) === "APPROVED" &&
        !isEscheatedTransaction(transaction)
    )
    .map((transaction) => transaction.transactionId);

export const getSelectableTransactionIds = (
  transactionList,
  approvedSelectable = true
) =>
  (transactionList || [])
    .filter((transaction) =>
      isBulkSelectableTransaction(transaction, approvedSelectable)
    )
    .map((transaction) => transaction.transactionId);

export const areAllSelectableChecked = (
  transactionList,
  checkedIds,
  approvedSelectable = true
) => {
  const selectableIds = getSelectableTransactionIds(
    transactionList,
    approvedSelectable
  );
  const checked = checkedIds || [];
  return (
    selectableIds.length > 0 &&
    selectableIds.every((id) => checked.includes(id))
  );
};

export const syncCheckedIdsWithPage = (
  transactionList,
  checkedIds,
  seedApproved,
  excludedApprovedIds,
  approvedSelectable = true
) => {
  const visibleIds = new Set(
    (transactionList || []).map((transaction) => transaction.transactionId)
  );
  const selectableIdSet = new Set(
    getSelectableTransactionIds(transactionList || [], approvedSelectable)
  );
  const excluded = excludedApprovedIds || new Set();

  let nextIds = (checkedIds || []).filter(
    (id) => visibleIds.has(id) && selectableIdSet.has(id)
  );

  if (seedApproved) {
    getApprovedTransactionIds(transactionList).forEach((id) => {
      if (!nextIds.includes(id) && !excluded.has(id)) {
        nextIds.push(id);
      }
    });
  }

  return nextIds;
};

export const getSummaryCheckboxPresentation = (
  confirmationStatus,
  isInRowsChecked,
  escheated = false,
  approvedSelectable = true
) => {
  if (escheated === true || escheated === 1) {
    return {
      checked: false,
      disabled: true,
      indeterminate: true,
      selectable: false,
    };
  }

  const status = normalizeStatus(confirmationStatus);

  if (status === "PAID") {
    return {
      checked: true,
      disabled: true,
      indeterminate: false,
      selectable: false,
    };
  }

  if (INDETERMINATE_STATUSES.includes(status)) {
    return {
      checked: false,
      disabled: true,
      indeterminate: true,
      selectable: false,
    };
  }

  if (status === "APPROVED" && approvedSelectable !== true) {
    return {
      checked: true,
      disabled: true,
      indeterminate: false,
      selectable: false,
    };
  }

  if (status === "READY" || status === "APPROVED") {
    return {
      checked: isInRowsChecked,
      disabled: false,
      indeterminate: false,
      selectable: true,
    };
  }

  return {
    checked: false,
    disabled: true,
    indeterminate: false,
    selectable: false,
  };
};
